import { onlineCityCode } from '~/data/fakeCities';

export const filterAvailableOnlineEvents = (events, currentCityKladr) => {
  return events.filter(
    event =>
      event.CITY_CODE !== onlineCityCode ||
      !event.AVAILABILITY_IN_CITIES?.length ||
      event.AVAILABILITY_IN_CITIES?.includes(currentCityKladr),
  );
};
